import { useModalContentToggler } from '@components'

import { Link, Space, Text } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from 'react-query'

import { UiSource } from '@features/reconciliation/enums'

import { useMatch, useMultiplePayableSubjects } from '../../../../contexts'
import { SubjectReconciliationModalStateId } from '../../../../enums/SubjectReconciliationModalStateId'
import { useDeleteSubjectReconciliationSuggestion } from '../../../../hooks'
import { getReconciliationQueryKeyFromSubject } from '../../../../utils'

export const LinkToBankLinesModal = (): ReactElement => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const { replaceActiveState } = useModalContentToggler()
  const { suggestion } = useMatch()
  const { initialSubject } = useMultiplePayableSubjects()

  const { deleteSuggestion } = useDeleteSubjectReconciliationSuggestion({
    onSuccess: () => {
      queryClient.invalidateQueries([getReconciliationQueryKeyFromSubject(initialSubject), initialSubject?.id])
    },
  })

  const handleLinkClick = useCallback(() => {
    replaceActiveState(SubjectReconciliationModalStateId.BankLines)

    if (suggestion && initialSubject?.organizationId) {
      deleteSuggestion({
        organizationId: initialSubject.organizationId,
        suggestion,
        uiSource: UiSource.PayAndRecon,
      })
    }
  }, [replaceActiveState, suggestion, initialSubject, deleteSuggestion])

  return (
    <>
      <Space />
      <Text colorVariant="secondary">
        {t('bill.payment_reconcile.not_the_right_match')}{' '}
        <Text as="span">
          <Link onClick={handleLinkClick}>{t('bill.payment_reconcile.choose_from_bank_transactions')}</Link>
        </Text>
      </Text>
    </>
  )
}
